export const LOGIN_START = "LOGIN_START"
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL"
export const LOGIN_FAILED = "LOGIN_FAILED"

export const GET_USERS_START = "GET_USERS_START"
export const GET_USERS_SUCCESSFUL = "GET_USERS_SUCCESSFUL"
export const GET_USERS_FAILED = "GET_USERS_FAILED"

export const GET_USER_START = "GET_USER_START"
export const GET_USER_SUCCESSFUL = "GET_USER_SUCCESSFUL"
export const GET_USER_FAILED = "GET_USER_FAILED"

export const UPDATE_USER_START = "UPDATE_USER_START"
export const UPDATE_USER_SUCCESSFUL = "UPDATE_USER_SUCCESSFUL"
export const UPDATE_USER_FAILED = "UPDATE_USER_FAILED"

export const POST_TEAM_STARTED = "POST_TEAM_STARTED"
export const POST_TEAM_SUCCESSFUL = "POST_TEAM_SUCCESSFUL"
export const POST_TEAM_FAILED = "POST_TEAM_FAILED"

export const UPDATE_TEAM_STARTED = "UPDATE_TEAM_STARTED"
export const UPDATE_TEAM_SUCCESSFUL = "UPDATE_TEAM_SUCCESSFUL"
export const UPDATE_TEAM_FAILED = "UPDATE_TEAM_FAILED"

export const GET_TEAM_STARTED = "GET_TEAM_STARTED"
export const GET_TEAM_SUCCESSFUL = "GET_TEAM_SUCCESSFUL"
export const GET_TEAM_FAILED = "GET_TEAM_FAILED"

export const GET_TEAMS_STARTED = "GET_TEAMS_STARTED"
export const GET_TEAMS_SUCCESSFUL = "GET_TEAMS_SUCCESSFUL"
export const GET_TEAMS_FAILED = "GET_TEAMS_FAILED"

export const POST_PLAYER_STARTED = "POST_PLAYER_STARTED"
export const POST_PLAYER_SUCCESSFUL = "POST_PLAYER_SUCCESSFUL"
export const POST_PLAYER_FAILED = "POST_PLAYER_FAILED"

export const GET_PLAYER_STARTED = "GET_PLAYER_STARTED"
export const GET_PLAYER_SUCCESSFUL = "GET_PLAYER_SUCCESSFUL"
export const GET_PLAYER_FAILED = "GET_PLAYER_FAILED"

export const DELETE_PLAYER_STARTED = "DELETE_PLAYER_STARTED"
export const DELETE_PLAYER_SUCCESSFUL = "DELETE_PLAYER_SUCCESSFUL"
export const DELETE_PLAYER_FAILED = "DELETE_PLAYER_FAILED"

export const GET_PLAYERS_STARTED = "GET_PLAYERS_STARTED"
export const GET_PLAYERS_SUCCESSFUL = "GET_PLAYERS_SUCCESSFUL"
export const GET_PLAYERS_FAILED = "GET_PLAYERS_FAILED"

export const UPDATE_PLAYER_STARTED = "UPDATE_PLAYER_STARTED"
export const UPDATE_PLAYER_SUCCESSFUL = "UPDATE_PLAYER_SUCCESSFUL"
export const UPDATE_PLAYER_FAILED = "UPDATE_PLAYER_FAILED"

export const ACCREDIT_PLAYER_STARTED = "ACCREDIT_PLAYER_STARTED"
export const ACCREDIT_PLAYER_SUCCESSFUL = "ACCREDIT_PLAYER_SUCCESSFUL"
export const ACCREDIT_PLAYER_FAILED = "ACCREDIT_PLAYER_FAILED"

export const ACCREDIT_OFFICIAL_STARTED = "ACCREDIT_OFFICIAL_STARTED"
export const ACCREDIT_OFFICIAL_SUCCESSFUL = "ACCREDIT_OFFICIAL_SUCCESSFUL"
export const ACCREDIT_OFFICIAL_FAILED = "ACCREDIT_OFFICIAL_FAILED"

export const GET_PLAYER_LICENSE_STARTED = "GET_PLAYER_LICENSE_STARTED"
export const GET_PLAYER_LICENSE_SUCCESSFUL = "GET_PLAYER_LICENSE_SUCCESSFUL"
export const GET_PLAYER_LICENSE_FAILED = "GET_PLAYER_LICENSE_FAILED"

export const POST_OFFICIAL_STARTED = "POST_OFFICIAL_STARTED"
export const POST_OFFICIAL_SUCCESSFUL = "POST_OFFICIAL_SUCCESSFUL"
export const POST_OFFICIAL_FAILED = "POST_OFFICIAL_FAILED"

export const GET_OFFICIAL_STARTED = "GET_OFFICIAL_STARTED"
export const GET_OFFICIAL_SUCCESSFUL = "GET_OFFICIAL_SUCCESSFUL"
export const GET_OFFICIAL_FAILED = "GET_OFFICIAL_FAILED"

export const GET_OFFICIALS_STARTED = "GET_OFFICIALS_STARTED"
export const GET_OFFICIALS_SUCCESSFUL = "GET_OFFICIALS_SUCCESSFUL"
export const GET_OFFICIALS_FAILED = "GET_OFFICIALS_FAILED"

export const UPDATE_OFFICIAL_STARTED = "UPDATE_OFFICIAL_STARTED"
export const UPDATE_OFFICIAL_SUCCESSFUL = "UPDATE_OFFICIAL_SUCCESSFUL"
export const UPDATE_OFFICIAL_FAILED = "UPDATE_OFFICIAL_FAILED"

export const GET_INSTITUTION_STARTED = "GET_INSTITUTION_STARTED"
export const GET_INSTITUTION_SUCCESSFUL = "GET_INSTITUTION_SUCCESSFUL"
export const GET_INSTITUTION_FAILED = "GET_INSTITUTION_FAILED"

export const GET_INSTITUTIONS_STARTED = "GET_INSTITUTIONS_STARTED"
export const GET_INSTITUTIONS_SUCCESSFUL = "GET_INSTITUTIONS_SUCCESSFUL"
export const GET_INSTITUTIONS_FAILED = "GET_INSTITUTIONS_FAILED"

export const POST_INSTITUTION_STARTED = "POST_INSTITUTION_STARTED"
export const POST_INSTITUTION_SUCCESSFUL = "POST_INSTITUTION_SUCCESSFUL"
export const POST_INSTITUTION_FAILED = "POST_INSTITUTION_FAILED"

export const GET_LEAGUE_STARTED = "GET_LEAGUE_STARTED"
export const GET_LEAGUE_SUCCESSFUL = "GET_LEAGUE_SUCCESSFUL"
export const GET_LEAGUE_FAILED = "GET_LEAGUE_FAILED"

export const GET_LEAGUE_STAGE_STARTED = "GET_LEAGUE_STAGE_STARTED"
export const GET_LEAGUE_STAGE_SUCCESSFUL = "GET_LEAGUE_STAGE_SUCCESSFUL"
export const GET_LEAGUE_STAGE_FAILED = "GET_LEAGUE_STAGE_FAILED"

export const GET_LEAGUE_STAGES_STARTED = "GET_LEAGUE_STAGES_STARTED"
export const GET_LEAGUE_STAGES_SUCCESSFUL = "GET_LEAGUE_STAGES_SUCCESSFUL"
export const GET_LEAGUE_STAGES_FAILED = "GET_LEAGUE_STAGES_FAILED"

export const GET_LEAGUES_STARTED = "GET_LEAGUES_STARTED"
export const GET_LEAGUES_SUCCESSFUL = "GET_LEAGUES_SUCCESSFUL"
export const GET_LEAGUES_FAILED = "GET_LEAGUES_FAILED"

export const POST_LEAGUE_STARTED = "POST_LEAGUE_STARTED"
export const POST_LEAGUE_SUCCESSFUL = "POST_LEAGUE_SUCCESSFUL"
export const POST_LEAGUE_FAILED = "POST_LEAGUE_FAILED"

export const POST_LEAGUE_STAGE_STARTED = "POST_LEAGUE_STAGE_STARTED"
export const POST_LEAGUE_STAGE_SUCCESSFUL = "POST_LEAGUE_STAGE_SUCCESSFUL"
export const POST_LEAGUE_STAGE_FAILED = "POST_LEAGUE_STAGE_FAILED"

export const UPDATE_LEAGUE_STARTED = "UPDATE_LEAGUE_STARTED"
export const UPDATE_LEAGUE_SUCCESSFUL = "UPDATE_LEAGUE_SUCCESSFUL"
export const UPDATE_LEAGUE_FAILED = "UPDATE_LEAGUE_FAILED"

export const UPDATE_LEAGUE_STAGE_STARTED = "UPDATE_LEAGUE_STAGE_STARTED"
export const UPDATE_LEAGUE_STAGE_SUCCESSFUL = "UPDATE_LEAGUE_STAGE_SUCCESSFUL"
export const UPDATE_LEAGUE_STAGE_FAILED = "UPDATE_LEAGUE_STAGE_FAILED"

export const GET_SEASON_STARTED = "GET_SEASON_STARTED"
export const GET_SEASON_SUCCESSFUL = "GET_SEASON_SUCCESSFUL"
export const GET_SEASON_FAILED = "GET_LEAGUE_FAILED"

export const GET_SEASONS_STARTED = "GET_SEASONS_STARTED"
export const GET_SEASONS_SUCCESSFUL = "GET_SEASONS_SUCCESSFUL"
export const GET_SEASONS_FAILED = "GET_SEASONS_FAILED"

export const POST_SEASON_STARTED = "POST_SEASON_STARTED"
export const POST_SEASON_SUCCESSFUL = "POST_SEASON_SUCCESSFUL"
export const POST_SEASON_FAILED = "POST_SEASON_FAILED"

export const UPDATE_SEASON_STARTED = "UPDATE_SEASON_STARTED"
export const UPDATE_SEASON_SUCCESSFUL = "UPDATE_SEASON_SUCCESSFUL"
export const UPDATE_SEASON_FAILED = "UPDATE_SEASON_FAILED"

export const POST_FILE_STARTED = "POST_FILE_STARTED"
export const POST_FILE_SUCCESSFUL = "POST_FILE_SUCCESSFUL"
export const POST_FILE_FAILED = "POST_FILE_FAILED"

export const GET_SPORT_STARTED = "GET_SPORT_STARTED"
export const GET_SPORT_SUCCESSFUL = "GET_SPORT_SUCCESSFUL"
export const GET_SPORT_FAILED = "GET_SPORT_FAILED"

export const POST_SETTING_STARTED = "POST_SETTING_STARTED"
export const POST_SETTING_SUCCESSFUL = "POST_SETTING_SUCCESSFUL"
export const POST_SETTING_FAILED = "POST_SETTING_FAILED"

export const GET_SETTING_STARTED = "GET_SETTING_STARTED"
export const GET_SETTING_SUCCESSFUL = "GET_SETTING_SUCCESSFUL"
export const GET_SETTING_FAILED = "GET_SETTING_FAILED"

export const GET_SINGLE_SETTING_STARTED = "GET_SINGLE_SETTING_STARTED"
export const GET_SINGLE_SETTING_SUCCESSFUL = "GET_SINGLE_SETTING_SUCCESSFUL"
export const GET_SINGLE_SETTING_FAILED = "GET_SINGLE_SETTING_FAILED"

export const UPDATE_SETTING_STARTED = "UPDATE_SETTING_STARTED"
export const UPDATE_SETTING_SUCCESSFUL = "UPDATE_SETTING_SUCCESSFUL"
export const UPDATE_SETTING_FAILED = "UPDATE_SETTING_FAILED"

export const SET_SELECTED_SETTING = "SET_SELECTED_FILE"
export const GET_SET_SELECTED_SETTING = "Get_SET_SELECTED_FILE"

export const POST_FIXTURE_STARTED = "POST_FIXTURE_STARTED"
export const POST_FIXTURE_SUCCESSFUL = "POST_FIXTURE_SUCCESSFUL"
export const POST_FIXTURE_FAILED = "POST_FIXTURE_FAILED"

export const GET_FIXTURE_STARTED = "GET_FIXTURE_STARTED"
export const GET_FIXTURE_SUCCESSFUL = "GET_FIXTURE_SUCCESSFUL"
export const GET_FIXTURE_FAILED = "GET_FIXTURE_FAILED"

export const GET_FIXTURES_STARTED = "GET_FIXTURES_STARTED"
export const GET_FIXTURES_SUCCESSFUL = "GET_FIXTURES_SUCCESSFUL"
export const GET_FIXTURES_FAILED = "GET_FIXTURES_FAILED"

export const UPDATE_FIXTURE_STARTED = "UPDATE_FIXTURE_STARTED"
export const UPDATE_FIXTURE_SUCCESSFUL = "UPDATE_FIXTURE_SUCCESSFUL"
export const UPDATE_FIXTURE_FAILED = "UPDATE_FIXTURE_FAILED"

export const POST_ORDER_STARTED = "POST_ORDER_STARTED"
export const POST_ORDER_SUCCESSFUL = "POST_ORDER_SUCCESSFUL"
export const POST_ORDER_FAILED = "POST_ORDER_FAILED"

export const GET_ORDER_STARTED = "GET_ORDER_STARTED"
export const GET_ORDER_SUCCESSFUL = "GET_ORDER_SUCCESSFUL"
export const GET_ORDER_FAILED = "GET_ORDER_FAILED"

export const GET_ORDERS_STARTED = "GET_ORDERS_STARTED"
export const GET_ORDERS_SUCCESSFUL = "GET_ORDERS_SUCCESSFUL"
export const GET_ORDERS_FAILED = "GET_ORDERS_FAILED"

export const UPDATE_ORDER_STARTED = "UPDATE_ORDER_STARTED"
export const UPDATE_ORDER_SUCCESSFUL = "UPDATE_ORDER_SUCCESSFUL"
export const UPDATE_ORDER_FAILED = "UPDATE_ORDER_FAILED"

export const POST_VOLUNTEER_STARTED = "POST_VOLUNTEER_STARTED"
export const POST_VOLUNTEER_SUCCESSFUL = "POST_VOLUNTEER_SUCCESSFUL"
export const POST_VOLUNTEER_FAILED = "POST_VOLUNTEER_FAILED"

export const GET_VOLUNTEER_STARTED = "GET_VOLUNTEER_STARTED"
export const GET_VOLUNTEER_SUCCESSFUL = "GET_VOLUNTEER_SUCCESSFUL"
export const GET_VOLUNTEER_FAILED = "GET_VOLUNTEER_FAILED"

export const GET_VOLUNTEERS_STARTED = "GET_VOLUNTEERS_STARTED"
export const GET_VOLUNTEERS_SUCCESSFUL = "GET_VOLUNTEERS_SUCCESSFUL"
export const GET_VOLUNTEERS_FAILED = "GET_VOLUNTEERS_FAILED"

export const UPDATE_VOLUNTEER_STARTED = "UPDATE_VOLUNTEER_STARTED"
export const UPDATE_VOLUNTEER_SUCCESSFUL = "UPDATE_VOLUNTEER_SUCCESSFUL"
export const UPDATE_VOLUNTEER_FAILED = "UPDATE_VOLUNTEER_FAILED"

export const GET_FANS_STARTED = "GET_FANS_STARTED"
export const GET_FANS_SUCCESSFUL = "GET_FANS_SUCCESSFUL"
export const GET_FANS_FAILED = "GET_FANS_FAILED"


export const POST_PLAYER_V2_STARTED = "POST_PLAYER_STARTED"
export const POST_PLAYER_V2_SUCCESSFUL = "POST_PLAYER_SUCCESSFUL"
export const POST_PLAYER_V2_FAILED = "POST_PLAYER_FAILED"

export const GET_PLAYER_V2_STARTED = "GET_PLAYER_STARTED"
export const GET_PLAYER_V2_SUCCESSFUL = "GET_PLAYER_SUCCESSFUL"
export const GET_PLAYER_V2_FAILED = "GET_PLAYER_FAILED"

export const DELETE_PLAYER_V2_STARTED = "DELETE_PLAYER_STARTED"
export const DELETE_PLAYER_V2_SUCCESSFUL = "DELETE_PLAYER_SUCCESSFUL"
export const DELETE_PLAYER_V2_FAILED = "DELETE_PLAYER_FAILED"

export const GET_PLAYERS_V2_STARTED = "GET_PLAYERS_STARTED"
export const GET_PLAYERS_V2_SUCCESSFUL = "GET_PLAYERS_SUCCESSFUL"
export const GET_PLAYERS_V2_FAILED = "GET_PLAYERS_FAILED"

export const UPDATE_PLAYER_V2_STARTED = "UPDATE_PLAYER_STARTED"
export const UPDATE_PLAYER_V2_SUCCESSFUL = "UPDATE_PLAYER_SUCCESSFUL"
export const UPDATE_PLAYER_V2_FAILED = "UPDATE_PLAYER_FAILED"

export const ACCREDIT_PLAYER_V2_STARTED = "ACCREDIT_PLAYER_STARTED"
export const ACCREDIT_PLAYER_V2_SUCCESSFUL = "ACCREDIT_PLAYER_SUCCESSFUL"
export const ACCREDIT_PLAYER_V2_FAILED = "ACCREDIT_PLAYER_FAILED"

export const GET_PLAYER_V2_LICENSE_STARTED = "GET_PLAYER_LICENSE_STARTED"
export const GET_PLAYER_V2_LICENSE_SUCCESSFUL = "GET_PLAYER_LICENSE_SUCCESSFUL"
export const GET_PLAYER_V2_LICENSE_FAILED = "GET_PLAYER_LICENSE_FAILED"

export const POST_OFFICIAL_V2_STARTED = "POST_OFFICIAL_V2_STARTED"
export const POST_OFFICIAL_V2_SUCCESSFUL = "POST_OFFICIAL_V2_SUCCESSFUL"
export const POST_OFFICIAL_V2_FAILED = "POST_OFFICIAL_V2_FAILED"

export const GET_OFFICIAL_V2_STARTED = "GET_OFFICIAL_V2_STARTED"
export const GET_OFFICIAL_V2_SUCCESSFUL = "GET_OFFICIAL_V2_SUCCESSFUL"
export const GET_OFFICIAL_V2_FAILED = "GET_OFFICIAL_V2_FAILED"

export const GET_OFFICIALS_V2_STARTED = "GET_OFFICIALS_V2_STARTED"
export const GET_OFFICIALS_V2_SUCCESSFUL = "GET_OFFICIALS_V2_SUCCESSFUL"
export const GET_OFFICIALS_V2_FAILED = "GET_OFFICIALS_V2_FAILED"

export const UPDATE_OFFICIAL_V2_STARTED = "UPDATE_OFFICIAL_V2_STARTED"
export const UPDATE_OFFICIAL_V2_SUCCESSFUL = "UPDATE_OFFICIAL_V2_SUCCESSFUL"
export const UPDATE_OFFICIAL_V2_FAILED = "UPDATE_OFFICIAL_V2_FAILED"

export const ACCREDIT_OFFICIAL_V2_STARTED = "ACCREDIT_OFFICIAL_STARTED"
export const ACCREDIT_OFFICIAL_V2_SUCCESSFUL = "ACCREDIT_OFFICIAL_SUCCESSFUL"
export const ACCREDIT_OFFICIAL_V2_FAILED = "ACCREDIT_OFFICIAL_FAILED"